import { Component, ElementRef, Input, OnInit, ViewContainerRef } from "@angular/core";

@Component({
    selector: "app-jump-list-item",
    templateUrl: "./jump-list-item.component.html"
})
export class JumpListItemComponent implements OnInit {
    
    @Input() itemName: string;
    @Input() targetElement: ElementRef["nativeElement"];
    private fixedHeaderEle: ElementRef["nativeElement"];
    constructor() {
    }
    ngOnInit(): void {
        this.fixedHeaderEle = document.getElementsByClassName('unified-header--sticky-enabled');
        this.fixedHeaderEle = this.fixedHeaderEle.length ? this.fixedHeaderEle[0].getElementsByClassName('unified-walled-header') : [];
        this.fixedHeaderEle = this.fixedHeaderEle.length ? this.fixedHeaderEle[0].offsetHeight  : 80;
    }
    public scrollTo(e: Event) {
        e.preventDefault();
        if (this.targetElement) {
            this.targetElement.setAttribute("tabindex", "-1");
            window.scrollTo({
                top: this.targetElement.offsetTop - this.fixedHeaderEle,
                behavior: "smooth"
            });
            this.targetElement.focus();
        }
    }

}